<template>
  <div class="adm-shell auth">
    <main class="auth__panel">
      <div class="auth__card">
        <router-link to="/" class="auth__logo" aria-label="Ir al sitio de Selk">
          <img :src="logo" alt="Selk" />
        </router-link>
        <slot />
      </div>

      <p class="auth__legal adm-muted">
        <router-link to="/privacidad">Privacidad</router-link>
        <span aria-hidden="true">·</span>
        <router-link to="/terminos">Términos</router-link>
        <span aria-hidden="true">·</span>
        <router-link to="/">Ir al sitio público</router-link>
      </p>
    </main>

    <!-- Panel de marca: sólo decorativo, se oculta en pantallas estrechas. -->
    <aside class="auth__brand" aria-hidden="true">
      <div class="auth__brand-inner">
        <h2 class="auth__brand-title">Dos pilares,<br />soluciones infinitas</h2>
        <p class="auth__brand-text">
          Construimos los sistemas que automatizan tu empresa y fabricamos las
          piezas que tus proyectos necesitan.
        </p>
      </div>
    </aside>

    <!-- El host de avisos también aquí: si no, el mensaje de "contraseña
         actualizada" se encola al navegar a /login y no lo pinta nadie. -->
    <AdmToastHost />
  </div>
</template>

<script>
/**
 * Layout de autenticación — plan 27_09_2026, adenda del 27/09.
 *
 * Las pantallas de acceso y recuperación colgaban del layout público, así que
 * mostraban la cabecera comercial ("Cotiza ahora"), el footer institucional y
 * el botón de WhatsApp alrededor de un formulario de login. Son la puerta del
 * panel, no una página de venta: aquí tienen su propio marco, con la misma
 * identidad que el área administrativa.
 */
import AdmToastHost from '@/components/Admin/ui/AdmToastHost.vue';
import logo from '@/assets/SELK_LOGO.svg';

export default {
  name: 'AuthLayout',
  components: { AdmToastHost },
  setup() {
    return { logo };
  },
};
</script>

<style scoped>
.auth {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  min-height: 100vh;
}

.auth__panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--adm-gap-lg);
  padding: var(--adm-content-pad);
}

.auth__card {
  display: flex;
  flex-direction: column;
  gap: var(--adm-gap-lg);
  width: 100%;
  max-width: 400px;
  padding: var(--adm-gap-lg);
  background-color: var(--adm-surface);
  border: 1px solid var(--adm-border);
  border-radius: var(--adm-radius);
  box-shadow: var(--adm-shadow);
}

.auth__logo {
  align-self: center;
}

.auth__logo img {
  display: block;
  width: 130px;
  height: auto;
}

.auth__legal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
  font-size: 0.78rem;
}

.auth__legal a {
  color: inherit;
  text-decoration: none;
}

.auth__legal a:hover {
  color: var(--color-brand);
  text-decoration: underline;
}

/* --- Panel de marca --- */
.auth__brand {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--adm-content-pad);
  /* Gama azul de la marca, del teal al azul pizarra del logotipo. */
  background: linear-gradient(145deg, var(--color-brand), var(--color-logo));
  color: var(--color-white);
}

.auth__brand-inner { max-width: 420px; }

.auth__brand-title {
  margin: 0 0 var(--adm-gap) 0;
  font-family: var(--font-subtitle);
  font-weight: 700;
  font-size: clamp(1.6rem, 3vw, 2.4rem);
  line-height: 1.15;
}

.auth__brand-text {
  margin: 0;
  font-family: var(--font-body);
  font-size: 1rem;
  line-height: 1.5;
  opacity: 0.92;
}

/* Por debajo de 900px el panel de marca desaparece: la tarjeta se queda sola
   y centrada, que es lo que importa en un móvil. */
@media (max-width: 900px) {
  .auth { grid-template-columns: minmax(0, 1fr); }
  .auth__brand { display: none; }
}
</style>
